import moment, { Moment } from 'moment/moment'
import { AdviceSection, AdviceSectionPayload } from '@/core/models/advice-section'
import { Stroke, StrokePayload } from '@/core/models/stroke'

export interface AdvicePayload {
    id: number
    advice_section_id: number
    stroke_id: number
    name: string
    description: string
    connected: string
    connected_id: number
    level: string
    author: string
    external_url: string
    published?: boolean
    sort_order: number
    created_at: string
    section?: AdviceSectionPayload
    stroke?: StrokePayload
    translations?: {}
}

export class Advice {

    id: number
    adviceSectionId: number
    strokeId: number
    name: string
    description: string
    connected: string
    connectedId: number
    level: string
    author: string
    externalUrl: string
    published: boolean
    sortOrder: number
    createdAt: Moment
    section: AdviceSection
    stroke: Stroke
    translations?: {} = <any>{}

    constructor(data: AdvicePayload) {
        this.id = data.id
        this.adviceSectionId = data.advice_section_id
        this.strokeId = data.stroke_id
        this.name = data.name
        this.description = data.description
        this.connected = data.connected
        this.connectedId = data.connected_id
        this.level = data.level
        this.author = data.author
        this.externalUrl = data.external_url
        this.published = !! data.published
        this.sortOrder = data.sort_order
        this.createdAt = moment(data.created_at)
        this.section = new AdviceSection(data.section || <any>{})
        this.stroke = new Stroke(data.stroke || <any>{})
        this.capture(data)
    }

    fill(data: AdvicePayload): this {
        this.id = data.id
        this.adviceSectionId = data.advice_section_id
        this.strokeId = data.stroke_id
        this.name = data.name
        this.description = data.description
        this.connected = data.connected
        this.connectedId = data.connected_id
        this.level = data.level
        this.author = data.author
        this.externalUrl = data.external_url
        this.published = !! data.published
        this.sortOrder = data.sort_order
        this.createdAt = moment(data.created_at)
        this.section = new AdviceSection(data.section || <any>{})
        this.stroke = new Stroke(data.stroke || <any>{})
        this.capture(data)
        return this
    }

    capture(data: AdvicePayload): this {
        if (data.translations) {
            this.translations = data.translations
        }
        return this
    }

    exists(): boolean {
        return !! this.id
    }

    unset(): void {
        this.fill(<any>{})
        this.translations = {}
    }

    payload(): AdvicePayload | any {
        return {
            id: this.id,
            advice_section_id: this.adviceSectionId,
            stroke_id: this.strokeId,
            name: this.name,
            description: this.description,
            connected: this.connected,
            connected_id: this.connectedId,
            level: this.level,
            author: this.author,
            external_url: this.externalUrl,
            published: this.published,
            sort_order: this.sortOrder,
            translations: this.translations,
        }
    }
}
